import { render, staticRenderFns } from "./D21.vue?vue&type=template&id=5341afa6&scoped=true"
import script from "./D21.vue?vue&type=script&lang=js"
export * from "./D21.vue?vue&type=script&lang=js"
import style0 from "./D21.vue?vue&type=style&index=0&id=5341afa6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5341afa6",
  null
  
)

export default component.exports